import { inventoryItemIdFormat } from "@redotech/redo-ims-id";
import { productIdFormat } from "@redotech/redo-product-id";
import {
  binCountSessionIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

const CountedItemSchema_ = z
  .object({
    productId: productIdFormat.schema.nullable(),
    quantity: z.number().int().min(0).max(1_000_000),
    inventoryItemIds: z.array(inventoryItemIdFormat.schema).default([]),
  })
  .superRefine((item, ctx) => {
    if (
      item.productId === null &&
      item.inventoryItemIds.length !== item.quantity
    ) {
      ctx.addIssue({
        code: "custom",
        path: ["inventoryItemIds"],
        message:
          "Productless inventory item counts must include exact inventory item IDs.",
      });
    }
  });
export const CountedItemSchema: z.ZodType<CountedItemSchema> =
  CountedItemSchema_;
export interface CountedItemSchema extends z.infer<typeof CountedItemSchema_> {}

export const confirmBinCount = {
  name: "confirmBinCount" as const,
  input: z.object({
    binCountSessionId: binCountSessionIdFormat.schema,
    storageLocationId: storageLocationIdFormat.schema,
    countedItems: z.array(CountedItemSchema).max(10_000),
  }),
  output: z.object({ success: z.boolean() }),
};
